import React, {useState} from "react"
import {useTranslation} from "react-i18next"
import {Cog6ToothIcon, PhoneIcon} from "@heroicons/react/24/outline"

import Button from "../../../components/Button.tsx"
import {useUserSettingsOrLogout} from "../../../queries/user.ts"
import {isSaaSCompanyUser} from "../../../utils/types.ts"
import {useCreateKlaraCall} from "../useCreateKlaraCall.tsx"
import {useKlaraPeriod} from "../useKlaraPeriod.ts"
import {KlaraSettingsModal} from "./KlaraSettingsModal.tsx"
import {PeriodSelector} from "./PeriodSelector.tsx"

export const Header: React.FC = () => {
  const {t} = useTranslation()
  const {user} = useUserSettingsOrLogout()
  const [period, setPeriod] = useKlaraPeriod()
  const {createCall, isPending} = useCreateKlaraCall()
  const [isSettingsOpen, setIsSettingsOpen] = useState(false)

  // Klara calls a sales person, so only a company user linked to one can be called.
  const canCreateCall = isSaaSCompanyUser(user) && user.sales_assistant_sales_person != null

  return (
    <div className={"mb-0.5 flex flex-wrap items-end justify-between gap-x-5 gap-y-3.5"}>
      <h1 className={"text-2xl leading-tight font-bold tracking-[-0.4px] text-cr-slate-90"}>
        {t("KlaraDashboard_Title")}
      </h1>
      <div className={"flex flex-wrap items-center gap-2.5"}>
        <PeriodSelector value={period} onChange={setPeriod} />
        <button
          type={"button"}
          aria-haspopup={"dialog"}
          onClick={() => setIsSettingsOpen(true)}
          className={
            "flex items-center gap-2 rounded-lg border border-cr-grey-15 bg-cr-white px-3 py-[7px] text-[12.5px] font-semibold whitespace-nowrap text-cr-slate-90 transition-colors hover:border-cr-blue-mid"
          }
        >
          <Cog6ToothIcon className={"size-[15px] text-cr-slate-60"} aria-hidden={"true"} />
          {t("KlaraDashboard_Settings_Button")}
        </button>
        {canCreateCall && (
          <Button
            iconLeft={<PhoneIcon />}
            size={"sm"}
            className={"rounded-lg py-[7px] text-[12.5px]"}
            isLoading={isPending}
            onClick={createCall}
          >
            {t("KlaraDashboard_CallMeNow_Button")}
          </Button>
        )}
      </div>
      {isSettingsOpen && <KlaraSettingsModal isOpen onClose={() => setIsSettingsOpen(false)} />}
    </div>
  )
}
